/**
 * @fileoverview Present configured matter-notification rules as compact summaries with explicit edit callbacks. `NotificationRules.js` owns catalog loading and `NotificationRuleForm.js` owns edits. These signifiers describe saved rule intent without evaluating matters or delivering Slack messages.
 */

import React from 'react'
import { AppBadge, AppButton } from '../shared'

const listStyle = {
    display: 'flex',
    flexDirection: 'column',
    gap: '0.85rem',
}

const cardStyle = {
    border: '1px solid var(--kc-surface-edge)',
    borderRadius: 'var(--admin-radius-lg)',
    backgroundColor: 'var(--kc-surface-focused)',
    padding: '1rem',
    display: 'flex',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    gap: '1rem',
    alignItems: 'flex-start',
}

const metaStyle = {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '0.5rem',
    marginBottom: '0.75rem',
}



function NotificationRuleChips({ notificationRules, openNotificationRuleFormInEditMode, slackChannels }) {
    return (
        <div style={listStyle}>
            {notificationRules.map((rule) => {
                const channelLabel = slackChannels.find(channel => channel.value === rule.SlackChannel)?.label || rule.SlackChannel
                const isAttributeRule = Array.isArray(rule.CaseAttributes) && rule.CaseAttributes.length > 0

                return (
                    <div key={rule.id || `${rule.State}-${channelLabel}`} style={cardStyle}>
                        <div style={{ flex: '1 1 30rem' }}>
                            <div style={metaStyle}>
                                <AppBadge value={isAttributeRule ? 'Missing Attributes' : 'State Timer'} severity={isAttributeRule ? 'warning' : 'info'} />
                                <AppBadge value={channelLabel || 'No Channel'} severity='secondary' />
                                <AppBadge value={`${rule.Days || 0} day${Number(rule.Days) === 1 ? '' : 's'}`} severity='success' />
                            </div>

                            <div style={{ fontSize: '0.9rem', color: 'var(--text-color)', lineHeight: 1.7 }}>
                                {buildDescription(rule, isAttributeRule)}
                            </div>
                        </div>

                        <div style={{ flex: '0 0 auto' }}>
                            <AppButton
                                icon='pi pi-pencil'
                                variant='secondary'
                                label='Edit'
                                onClick={() => openNotificationRuleFormInEditMode(rule)}
                            />
                        </div>
                    </div>
                )
            })}
        </div>
    )
}



function buildDescription(rule, isAttributeRule) {
    if (isAttributeRule) {
        const states = Array.isArray(rule.States) ? rule.States.filter(Boolean).join(', ') : ''
        const attributes = Array.isArray(rule.CaseAttributes) ? rule.CaseAttributes.filter(Boolean).join(', ') : ''
        return `Alert when a case remains in ${states || 'the selected states'} for at least ${rule.Days || 0} days and is still missing any of: ${attributes || 'selected attributes'}.`
    }

    return `Alert when a case remains in ${rule.State || 'the selected state'} for at least ${rule.Days || 0} days.`
}

export default NotificationRuleChips
